import { useContext } from 'react';
import RulesContext from './RulesContext';

const useRulesContext = () => useContext(RulesContext);

export default useRulesContext;
